import { Layout } from "../components/Layout";
import { Hero } from "../components/Hero";
import { Contact } from "../components/Contact";
import { Seo } from "../components/Seo";
import {
  TrustedBy, AboutIntro, StrategicFoundation, Numbers, ServicesShowcase, NorbitShowcase, IndustriesGrid,
  PortfolioGrid, CaseStudiesPreview, ProcessSteps, TechMarquee, WhyChoose,
  Testimonials, BlogsPreview, FAQ,
} from "../components/Sections";
import { FAQS, TAGLINE, COMPANY_CORE_THOUGHT, LEGAL_ENTITY, SOCIAL_LINKS } from "../data";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NeuraVolt Technology",
    "legalName": LEGAL_ENTITY,
    "url": "https://neuravolt.in",
    "slogan": TAGLINE,
    "logo": "https://neuravolt.in/assets/logo.png",
    "description": COMPANY_CORE_THOUGHT,
    "foundingDate": "2024",
    "email": "info@neuravolt.in",
    "telephone": "+919202243725",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "E Block, 511, Amity Innovation Center",
      "addressLocality": "Gwalior",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "474020",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 26.2183,
      "longitude": 78.1828
    },
    "sameAs": [
      SOCIAL_LINKS.linkedin,
      SOCIAL_LINKS.linkedin_profile,
      SOCIAL_LINKS.instagram,
      SOCIAL_LINKS.github,
      SOCIAL_LINKS.google_maps,
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "telephone": "+919202243725",
      "email": "info@neuravolt.in",
      "url": "https://neuravolt.in/contact",
      "availableLanguage": ["English", "Hindi"]
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Neuravolt",
    "url": "https://neuravolt.in"
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQS.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  }
];

export default function Home() {
  return (
    <Layout>
      <Seo
        title=""
        description="Technology is becoming more powerful, but increasingly fragmented. NeuraVolt exists to bring it together into one integrated ecosystem, continuously evolving through innovation. Bringing intelligent solutions for measurable impact across AI, cloud infrastructure, and enterprise platforms."
        keywords="Neuravolt, Bringing Intelligent Solutions for Measurable Impact, connected technology ecosystem, integrated technology company, autonomous digital engineering, custom software development India, AI solutions, sovereign enterprise operating system, cloud infrastructure, ERP CRM HRMS, VOLTNOVATE SOLUTIONS LLP, Gwalior"
        path="/"
        jsonLd={jsonLd}
      />
      {/* 1 & 2. Hero Fold */}
      <Hero />
      {/* 3. Trusted by Businesses Across the Globe */}
      <TrustedBy />
      {/* 4. Who we are? */}
      <AboutIntro />
      {/* 4.5 The NeuraVolt Foundation: Purpose, Vision, Mission & Core Thought */}
      <StrategicFoundation />
      <Numbers />
      {/* 5. What we do? Services & Products Engineered for Scale */}
      <ServicesShowcase />
      {/* 6. Who we've worked for? */}
      <IndustriesGrid />
      {/* 7. What We've Built */}
      <PortfolioGrid isHome={true} />
      {/* 8. How do We Operate? */}
      <ProcessSteps />
      {/* 9. What Fuels Our Services (Our Stack Section) */}
      <TechMarquee />
      {/* 10. Real Work, Real Stories (Case Studies) */}
      <CaseStudiesPreview />
      {/* 11. Why Choose Us? */}
      <WhyChoose />
      {/* 12. What Do Our Clients Say? */}
      <Testimonials />
      {/* 13. Blog preview */}
      <BlogsPreview />
      {/* 14. FAQ */}
      <FAQ />
      {/* 15. Contact (single callout, duplicate CTA removed) */}
      <Contact />
    </Layout>
  );
}
